import AuthService from 'services/AuthService'

export default {
    handle(to, from, next) {
        AuthService.loadSession().then(() => {
            if (AuthService.isPracticeAncillary()) {
                return next()
            }

            next({
                name: 'index.home',
            })
        })
    },
}
